export default __webpack_public_path__ + "static/media/gold3.f467403e.png";